import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

import CalendlyButton from '../CalendlyButton/CalendlyButton.jsx'

import {generate} from '../../routes.js'

import './IllustratedDivVertical.scss'

export default class IllustratedDivVertical extends PureComponent {
  static propTypes = {
    imgAlt: PropTypes.string,
    imgSrc: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
    linkCalendly: PropTypes.string,
    linkText: PropTypes.string.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <div className="illustrated-div-vertical mb-4 mb-lg-0 d-flex flex-column align-items-start align-items-lg-stretch justify-content-lg-between">
        <h2 className="text-left text-lg-center title pt-3 pt-lg-4">{this.props.title}</h2>
        {this.props.icon ?
          <div className="text-center d-none d-lg-block p-3">{this.props.icon}</div> :
          <div className="text-center d-none d-lg-block">
            <img className=" w-100" alt={this.props.imgAlt} src={this.props.imgSrc}/>
          </div>
        }
        <p className="" dangerouslySetInnerHTML={{__html: this.props.text}}></p>

        <div className="text-center py-3 py-lg-4 w-100 d-md-block">
          {this.props.linkCalendly ?
            <CalendlyButton meetingUrl={this.props.linkCalendly}>{this.props.linkText}</CalendlyButton> :
            <Link className="btn btn-primary" to={generate({name: this.props.link})}>
              {this.props.linkText}
            </Link>
          }
        </div>
      </div>
    )
  }
}
